import { render, staticRenderFns } from "./textElement.vue?vue&type=template&id=30df9ace&scoped=true"
import script from "./textElement.vue?vue&type=script&lang=js"
export * from "./textElement.vue?vue&type=script&lang=js"
import style0 from "./textElement.vue?vue&type=style&index=0&id=30df9ace&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30df9ace",
  null
  
)

export default component.exports